exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.15);padding-top:50%;padding-left:50%;z-index:999999}", ""]);

